import 'bootstrap';
import { CountUp } from 'countup.js';
import Macy from 'macy';
import './view-search-sticky-textbox';

(function (Drupal, once) {
  'use strict';
  Drupal.behaviors.accioncontraelhambre = {
    attach: function (context, settings) {
      setTimeout(function() {
        // https://www.drupal.org/project/critical_css/issues/3167636
        // The maintainer refuses to fix a bug with critical CSS and toolbar
        // so it is more optimal to update the toolbar height.
        if (Drupal.toolbar && Drupal.toolbar.views && Drupal.toolbar.views.toolbarVisualView
          && typeof (Drupal.toolbar.views.toolbarVisualView.updateToolbarHeight) === 'function'
        ) {
          Drupal.toolbar.views.toolbarVisualView.updateToolbarHeight();
        }

        once('accioncontraelhambre_facets', '.modal[id^="facets-modal-"]', context).forEach(function (modal) {
          // The vlsuite layout wrappers carry `contain: paint`, which makes
          // them the containing block of the fixed-position modal. WebKit then
          // paints the dialog and hit-tests it in different places, so on iOS
          // every tap inside it lands on the modal backdrop and dismisses it
          // instead of checking the facet. Lift the containment for as long as
          // the modal is open.
          // @see src/scss/base/_vlsuite-utilities.scss
          var uncontained = [];
          var restoreTimer = null;

          function restoreContainment() {
            window.clearTimeout(restoreTimer);
            uncontained.splice(0).forEach(function (entry) {
              entry.element.style.contain = entry.contain;
            });
          }

          modal.addEventListener('show.bs.modal', function () {
            restoreContainment();
            var node = modal.parentElement;
            while (node && node !== document.documentElement) {
              if (window.getComputedStyle(node).contain !== 'none') {
                uncontained.push({ element: node, contain: node.style.contain });
                node.style.contain = 'none';
              }
              node = node.parentElement;
            }
          });

          // Views AJAX can tear the modal out of the DOM mid-transition, in
          // which case `hidden` never arrives; the timer keeps the containment
          // from being lost for the rest of the page's life.
          modal.addEventListener('hide.bs.modal', function () {
            restoreTimer = window.setTimeout(restoreContainment, 1000);
          });
          modal.addEventListener('hidden.bs.modal', restoreContainment);

          // Close the facets modal as soon as a filter inside it is checked.
          // Bootstrap must be told to close it *before* Better Exposed
          // Filters' auto-submit fires the exposed form's Views AJAX submit
          // and replaces the form (and the modal wrapping it, see
          // facet-block.twig)
          modal.addEventListener('change', function () {
            var facetModalCloseButton = modal.querySelector('.btn-close');
            if (facetModalCloseButton) {
              facetModalCloseButton.click();
            }
          });
        });

        once('accioncontraelhambre_menu_column', 'ul.main-menu.navbar-nav .dropdown-menu', context).forEach(function (element, index) {
          var innerMenu = element.querySelector('.nav-child--level-2');
          if (innerMenu.childElementCount > 5) {
            element.classList.add('menu-two-columns');
          }
        });

        once('accioncontraelhambre_emergency_map', '.vlsuite-block__emergencies-map .emergency--teaser', context).forEach(function (element, index) {
          element.addEventListener('click', function () {
            var selectedID = element.getAttribute('id');
            var mapMarkers = document.querySelectorAll('.leaflet-marker-icon span');
            mapMarkers.forEach(function (mapMarker) {
              if (mapMarker.textContent === selectedID) {
                mapMarker.click();
              }
            });
          });
        });

        once('accioncontraelhambre_cookies', '.block--cookiesui', context).forEach(function (element, index) {
          const targetNode = document.getElementById("cookiesjsr");
          const config = { attributes: true, childList: true, subtree: true };
          const callback = (mutationList, observer) => {
            for (const mutation of mutationList) {
              if (mutation.type === "childList") {
                IsCookieBannerPresent();
              }
            }
          };
          const observer = new MutationObserver(callback);
          observer.observe(targetNode, config);

          function IsCookieBannerPresent() {
            const body = document.querySelector('body');
            const banner = element.querySelector('.cookiesjsr-banner');
            if (banner) {
              body.classList.add('cookiesjsr-banner--open');
            }
            else {
              body.classList.remove('cookiesjsr-banner--open');
            }
          }
        });

        once('accioncontraelhambre_countup', '.paragraph--type--mission-key-features', context).forEach(function (element) {
          const number = element.querySelectorAll('.field--name-field-number');
          number.forEach(function (numberElement) {
            const countUp = new CountUp(numberElement, numberElement.textContent, {
              duration: 3,
              useGrouping: false,
              enableScrollSpy: true,
              useEasing: true,
            });
            countUp.start();
          });
        });

        once('accioncontraelhambre_vlsuite-extensible-text', '.vlsuite-extensible-text', context).forEach(function (element) {
          if (element.offsetHeight < 280) {
            element.classList.toggle('vlsuite-extensible-text--skip');
            return;
          }
          else {
            element.classList.toggle('vlsuite-extensible-text--init');
          }
          var togglerLink = document.createElement('a');
          togglerLink.href = '#';
          togglerLink.title = Drupal.t('Read more');
          togglerLink.appendChild(document.createTextNode('expand_circle_down'));
          togglerLink.classList.add('vlsuite-extensible-text__toggler', 'vlsuite-icon-font-icon', 'material-symbols-outlined');
          togglerLink.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            element.classList.toggle('vlsuite-extensible-text--open');
            if (e.target.closest('.swiper-initialized') && e.target.closest('.swiper-initialized').swiper) {
              setTimeout(function () {
                e.target.closest('.swiper-initialized').swiper.update();
              }, 250);
            }
          });
          element.appendChild(togglerLink);
        });

        once('accioncontraelhambre_vlsuite-card-dropdown', '.vlsuite-block__vlsuite-collection-card.vlsuite_collection_card--view-mode-vlsuite_collection_5 .vlsuite-layout-bg-wrapper .vlsuite-layout', context).forEach(function (element) {
          var card = element;
          var popup = card.querySelector('.field--name-field-dropdown-text');
          var cards = document.querySelectorAll('.vlsuite-block__vlsuite-collection-card.vlsuite_collection_card--view-mode-vlsuite_collection_5 .vlsuite-layout-bg-wrapper .vlsuite-layout');
          card.addEventListener('click', function () {
            togglePopup();
          });
          function togglePopup() {
            // If users click the same person, close the popup
            if (card.classList.contains('is-active')) {
              cards.forEach(function (member) {
                var desc = member.querySelector('.field--name-field-dropdown-text');
                desc.style.display = 'none';
                card.classList.remove('is-active');
                card.style.removeProperty('padding-bottom');
              });
            } else {
              cards.forEach(function (member) {
                var desc = member.querySelector('.field--name-field-dropdown-text');
                desc.style.display = 'none';
                member.classList.remove('is-active');
                member.style.removeProperty('padding-bottom');
              });
              popup.style.display = 'block';
              card.classList.add('is-active');
              card.style.paddingBottom = popup.offsetHeight + 30 + 'px';
            }
          }
        });

        once('accioncontraelhambre_image_credit', 'article.news.news--full', context).forEach(function (element) {
          var image = element.querySelector('.field--name-field-image img');
          var credit = element.querySelector('button.news-photo-credit');
          // The button is only rendered when the caption is filled.
          if (!credit) {
            return;
          }
          document.addEventListener('click', (event) => {
            let target = event.target;
            if (!target.matches('button.news-photo-credit')) {
              credit.classList.remove('active')
              return;
            }
            if (target.classList.contains('active')) {
              target.classList.remove('active');
            }
            else {
              target.classList.add('active');
            }
          });
        });

        once('accioncontraelhambre_image_credit', 'article.press.press--full', context).forEach(function (element) {
          var image = element.querySelector('.field--name-field-image img');
          var credit = element.querySelector('button.press-photo-credit');
          // The button is only rendered when the caption is filled.
          if (!credit) {
            return;
          }
          document.addEventListener('click', (event) => {
            let target = event.target;
            if (!target.matches('button.press-photo-credit')) {
              credit.classList.remove('active')
              return;
            }
            if (target.classList.contains('active')) {
              target.classList.remove('active');
            }
            else {
              target.classList.add('active');
            }
          });
        });

        once('accioncontraelhambre_has_selector_add_class', '.vlsuite-block .view-hide-wrapping-block-when-empty', context).forEach(function (mainElement) {
          hasSelectorParentAddClass(mainElement, '.vlsuite-layout-onecol-bg-wrapper', '.view-empty', 'conditionally-hidden');
        });

        once('accioncontraelhambre_local_tasks', '.node-layout-builder-form', context).forEach(function (mainElement) {
          hasSelectorParentAddClass(mainElement, 'body', '.node-layout-builder-form', 'node-layout-builder-form-path');
        });


        once('accioncontraelhambre_countup_increasing_numbers', '.vlsuite-block__increasing-numbers', context).forEach(function (element) {
          const number = element.querySelectorAll('.field--name-field-number');
          number.forEach(function (numberElement) {
            const countUp = new CountUp(numberElement, numberElement.textContent, {
              duration: 3,
              useGrouping: false,
              enableScrollSpy: true,
              useEasing: true,
              decimalPlaces: parseInt(numberElement.textContent) == numberElement.textContent ? 0 : 1,
            });
            countUp.start();
          });
        });

        document.querySelectorAll('.press-view-search').forEach(function (element) {
          initMacy(element, '.macy');
        });

        document.querySelectorAll('.view-search').forEach(function (element) {
          initMacy(element, '.macy');
        });

        document.querySelectorAll('.news-view-search').forEach(function (element) {
          initMacy(element, '.macy');
        });

        document.querySelectorAll('.press-view-search').forEach(function (element) {
          initMacy(element, '.macy');
        });

        document.querySelectorAll('.events-view-search').forEach(function (element) {
          initMacy(element, '.macy');
        });

        document.querySelectorAll('.view-practices').forEach(function (element) {
          initMacy(element, '.macy');
        });

        document.querySelectorAll('.publishing-view-search').forEach(function (element) {
          initMacy(element, '.macy');
        });

      })
      function initMacy(element, macyContainerSelector) {
        once('accioncontraelhambre_macy_views', element, context).forEach(function (element) {
          var macyContainer = new Macy({
            container: element.querySelector(macyContainerSelector),
            trueOrder: false,
            waitForImages: true,
            margin: {
              x: 0,
              y: 24
            },
            columns: 4,
            breakAt: {
              1280: 3,
              768: 2,
              576: 1,
            }
          });
          macyContainer.recalculate();
        });
      }
    }

  };

  /**
   * Has selector parent add class.
   */
  function hasSelectorParentAddClass(main_element, parent_selector, inner_selector_to_check, class_to_add) {
    //console.log(main_element, parent_selector, inner_selector_to_check, class_to_add);
    if (parent_selector !== null && main_element.closest(parent_selector) && main_element.closest(parent_selector).querySelector(inner_selector_to_check)) {
      main_element.closest(parent_selector).classList.add(class_to_add);
    }
    else if (main_element.querySelector(inner_selector_to_check)) {
      main_element.classList.add(class_to_add);
    }
  }


})(Drupal, once);
